import { useState } from 'react';
import styles from './styles.module.scss';

export function Zipcodes({ deliveryZips }) {
	const [showAll, setShowAll] = useState(false);

	// Extract and sort zip codes numerically
	const sortedZips =
		deliveryZips && [...deliveryZips].map((zip) => zip.zipcode).sort((a, b) => parseInt(a) - parseInt(b));
	const initialZipsToShow = 8;

	return (
		<div className={styles.list}>
			<h2>Zipcodes We Deliver To</h2>
			<ul className="auto-grid" role="list">
				{showAll
					? sortedZips.map((zip, index) => <li key={`${zip}-${index}`}>{zip}</li>)
					: sortedZips?.length > 0 &&
					sortedZips.slice(0, initialZipsToShow).map((zip, index) => (
						<li key={`${zip}-${index}`}>{zip}</li>
					))}
			</ul>
			{deliveryZips?.length > initialZipsToShow && (
				<button
					className="button"
					data-type="text"
					onClick={() => setShowAll(!showAll)}
				>
					{showAll ? "Show Less -" : "Show All +"}</button>
			)}
		</div>
	);
}